<template>
  <div>
    <div class="content-header">
      <div class="left">客户等级</div>
      <div class="right">
        <Button
          icon="md-add"
          type="primary"
          @click="EDIT(false)"
          v-if="$CheckShow($route.name,'ADD')"
        >新增等级</Button>
      </div>
    </div>

    <Table :columns="columns" :data="list">
      <template slot-scope="{ row }" slot="action" fixed="right">
        <Button
          type="primary"
          size="small"
          @click="EDIT(row)"
          style="margin-right:5px"
          v-if="$CheckShow($route.name,'EDIT') && !row.is_default"
        >编辑</Button>
         <Button
          type="error"
          size="small"
          @click="delte(row)"
          v-if="$CheckShow($route.name,'EDIT')"
        >刪除</Button>
      </template>
    </Table>
    <Modal
      :title="modal.title"
      v-model="modal.status"
      width="600"
      class-name="vertical-center-modal"
      @on-ok="save"
    >
      <div>
        <Form ref="form" :model="modal.data" :rules="modal.rule" inline :label-width="120">
          <FormItem prop="name" label="等级名称:">
            <Input v-model="modal.data.name" style="width: 220px;"></Input>
            <div class="tips">示例：VIP1会员、VIP2会员、一级经销商、二级经销商</div>
          </FormItem>
          <br />
          <FormItem prop="discount" label="等级折扣:">
                        <!-- :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')" -->
            <InputNumber
            v-model="modal.data.discount"
            :precision='1'
            :min='0.01'
            :max='10'
            style="width: 220px;">
            </InputNumber>
            <span style="margin-left:6px">折</span>  
            <div class="tips">客户在标准的零售价或批发价的基础上可额外享受对应的折扣优惠，如打8.5折请填入数字8.5，无折扣填数字10</div>
          </FormItem>
          <br />
          <FormItem prop="type" label="客户类型:">
            <Select v-model="modal.data.type" style="width:220px">
              <Option :value="0" :key="0">会员</Option>
              <Option :value="1" :key="1">经销商</Option>
            </Select>
            <router-link :to="{name:''}" style="margin-left:20px;">
                <span style="font-size:12px">查看区别</span>
            </router-link>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="modal.status = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      modal: {
        status: false,
        loading: false,
        title: "新增客户等级",
        rule: {
          id: [
            {
              required: true,
              type: "number",
              message: "请填写类型编号",
              trigger: "select"
            }
          ],
          name: [
            {
              required: true,
              type: "string",
              message: "请填写等级名称",
              trigger: "select"
            }
          ],
          discount: [
            {
              required: true,
              type: "number",
              message: "请填写等级折扣",
              trigger: "select"
            }
          ],
          type: [
            {
              required: true,
              type: "number",
              message: "请选择客户类型",
              trigger: "select"
            }
          ]
        },
        data: {
          name: "",
          discount: "",
          type: 0
        }
      },
      search: {
        cond: "",
        loading: false,
        data: []
      },
      list: [],
      page: {
        l: 10,
        p: 0,
        name: "",
        no: "",
        total: 0,
        search: "",
        searchKey: "",
        status: ""
      },
      columns: [
        {
          title: "编号",
          key: "id"
        },
        {
          title: "等级名称",
          key: "name"
        },
        {
          title: "等级折扣",
          key: "discount_string"
        },
        {
          title: "客户类型",
          key: "type",
          render(h, data) {
            const arr = ["会员", "经销商"];
            return h("span", {}, arr[data.row.type]);
          }
        },
        {
          title: "操作",
          slot: "action",
          width: 140
        }
      ]
    };
  },
  methods: {
    ...mapActions(["getClientType", "SaveClientType","DelCustomerType"]),

    EDIT(row) {
      if (!row) {
        this.modal.status = true;
        this.modal.title = "新增";
        this.modal.data = {
          id: '',
          name: '',
          discount: '',
          type: ''
        }
      } else {
        this.modal.data = {
          id: row.id,
          name: row.name,
          discount: row.discount/10,
          type: row.type
        };
        this.modal.status = true;
        this.modal.title = "编辑";
      }
    },
    delte(row){
       if(row.name=='注册经销商'){
         this.$Message.error('系统默认项，不能删除!');
         return;
       }
       this.$Modal.confirm({
          title: "重要提醒",
          content: "您确定删除该项吗？",
          onOk: () => {
            this.DelCustomerType({id:row.id}).then((res) => {
              if (res.status === true) {
                this.$Message.success(res.msg);
                this.getData();
              }else{
                this.$Message.error(res.msg);
              }
            });
          },
        });
    },
    save() {
      this.modal.loading = true;
      this.modal.data.discount = this.modal.data.discount*10;
      this.SaveClientType(this.modal.data).then(res => {
        if (res.status) {
          this.$Message.success(res.msg);
          this.modal.status = false;
          this.modal.data = {
            id: "",
            name: "",
            discount: ""
          };
          this.getData();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },

    getData() {
      this.getClientType().then(res => {
        res.data.map(item => {
          if(item.discount==100){
            item.discount_string = "无折扣";
          }else{
            item.discount_string = item.discount/10 + "折";
          }
        });
        this.list = res.data;
      });
    },
    Up(row) {
      let data = {
        status: row.status !== 0 ? 0 : 1,
        id: row.id
      };
      this.UpBuygifts(data).then(res => {
        if (res.status) {
          this.$Message.success(res.msg);
          this.Reset();
          return false;
        }
        this.$Message.error(res.msg);
      });
    }
  },
  mounted() {
    this.getData();
  },
  created() {}
};
</script>

<style>
  .tips{
    font-size: 12px;
    color: #aaa;
    line-height: 20px;
  }
</style>
